import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { ManagerAdminBaseQueryDocument } from '@docpace/manager-graphql/dist/urql.types'
import { ManagerAdminBaseQueryResultFragment, ManagerAdminBaseQueryParams } from '@docpace/manager-graphql'
import { useAtom } from 'jotai'
import { ctxAdminIdAtom } from '@docpace/shared-react-atoms'

const typedManagerAdminBaseQueryDocument = ManagerAdminBaseQueryDocument as TypedDocumentNode<ManagerAdminBaseQueryResultFragment, Partial<ManagerAdminBaseQueryParams>>

export function useManagerAdminBaseQuery(opts?: useQuery.Options<ManagerAdminBaseQueryResultFragment, Partial<ManagerAdminBaseQueryParams>>){
    return useQuery(typedManagerAdminBaseQueryDocument, opts)
}

export function useContextManagerAdminBaseQuery(){
    const [ adminId ] = useAtom(ctxAdminIdAtom)
    const queryResult = useManagerAdminBaseQuery({
        variables: { adminId },
        skip: !adminId,
    })

    return {
        ...queryResult,
        admin: queryResult?.data?.admin
    }
}